import Breadcrumbs from '@components/common/Breadcrumbs';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import api from '@utils/api';
import ConnectivityForm from './ConnectivityForm';
import classNames from 'classnames';
import { FibraIcon, RameIcon, RadioIcon, MistoRadioIcon } from './connectivityIcons';
import AddressNotFoundModal from './ConnectivityAddressNotFound';
import analyticsUtils from '../../scripts/utilities/analyticsUtils';
const ConnectivityPage = (props) => {
    const { t } = props;
    const { customer } = useSelector((state) => state.connectivity);
    const [connectivityFormResponse, setConnectivityFormResponse] = useState(null);
    const [activeError, setActiveError] = useState();
    const [addressSuggestions, setAddressSuggestions] = useState([]);
    const [verifyCoveragePayload, setVerifyCoveragePayload] = useState(null);
    const [opnetCoverageResponse, setOpnetCoverageResponse] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const mapCheckAddressSuggestions = (suggestions, civic) => {
        const mappedSuggestions = suggestions.map((item) => ({
            codice_provincia: item.codice_provincia,
            provincia: item.provincia,
            indirizzo: item.indirizzo,
            cap: item.cap,
            egon_code: item.egon_code,
            civic_number: civic
        }));
        setAddressSuggestions(mappedSuggestions);
    };
    const mapCheckAddressResponse = (response) => {
        const verifyCoveragePayload = {
            AccountNumber: props.coverageaccountnumber || "",
            EgonCivico: response.data.details.egon_code || "",
            Provincia: response.data.details.Provincia || "",
            Comune: response.data.details.Comune || "",
            ParticellaToponomastica: response.data.details.Toponomastica || "",
            Indirizzo: response.data.details.Indirizzo || "",
            Civico: response.data.details.Civico || "",
            Error: response.data.error,
        };
        setVerifyCoveragePayload(verifyCoveragePayload);
    };
    const manageCheckAddressResponse = (response, civic) => {
        if (response.error || (response === null || response === void 0 ? void 0 : response.data) === null) {
            setIsModalOpen(true);
        }
        else if (Array.isArray(response.data.details)) {
            mapCheckAddressSuggestions(response.data.details, civic);
        }
        else {
            mapCheckAddressResponse(response);
        }
    };
    const setConnectivityForm = (coverageResponse) => {
        setConnectivityFormResponse(coverageResponse);
    };
    useEffect(() => {
        if (connectivityFormResponse) {
            api
                .CheckAddress(connectivityFormResponse.city, connectivityFormResponse.address + ' ' + connectivityFormResponse.civic)
                .then((data) => {
                manageCheckAddressResponse(data, connectivityFormResponse.civic);
            })
                .catch((err) => {
                console.error('Errore nella chiamata CheckAddress:', err);
            });
        }
    }, [connectivityFormResponse]);
    const sendDataLayerConnectivityResult = (coverage) => {
        let pid = document.querySelector('.connectivity-container').getAttribute('data-pid');
        let data = {
            'forcedPipeline': 'ConnectivityResult',
            'pid': pid,
            'coverageResult': coverage
        };
        analyticsUtils.passThroughProcessor(data);
    };
    useEffect(() => {
        if (verifyCoveragePayload && verifyCoveragePayload.Error === '') {
            api
                .VerifyCoverage(verifyCoveragePayload)
                .then((resp) => {
                if (resp && resp.data) {
                    saveOpnetCoverageResponse(resp.data);
                }
                else {
                    setOpnetCoverageResponse({ result: 'no_coverage' });
                    sendDataLayerConnectivityResult(false);
                }
            })
                .catch((err) => {
                console.error('Errore nella chiamata VerifyCoverage:', err);
                setOpnetCoverageResponse({ result: 'no_coverage' });
                sendDataLayerConnectivityResult(false);
            });
        }
        else if (verifyCoveragePayload && verifyCoveragePayload.Error) {
            console.error('Errore nei dati di CheckAddress:', verifyCoveragePayload.Error);
            setOpnetCoverageResponse({ result: 'no_coverage' });
            sendDataLayerConnectivityResult(false);
        }
    }, [verifyCoveragePayload]);
    useEffect(() => {
        if (addressSuggestions.length > 0) {
            openSuggestionsModal();
        }
    }, [addressSuggestions]);
    const openSuggestionsModal = () => {
        let pid = document.querySelector('.connectivity-container').getAttribute('data-pid');
        let data = {
            'forcedPipeline': 'ConnectivityModal',
            'pid': pid
        };
        analyticsUtils.passThroughProcessor(data);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const handleVerifyCoverage = (selection) => {
        if ('choice' in selection) {
            if (selection.choice === "Mantieni il mio indirizzo") {
                const verifyCoveragePayload = {
                    AccountNumber: props.coverageaccountnumber || "",
                    EgonCivico: "",
                    Provincia: "",
                    Comune: connectivityFormResponse.city || "",
                    ParticellaToponomastica: "",
                    Indirizzo: connectivityFormResponse.address || "",
                    Civico: connectivityFormResponse.civic || "",
                    Error: "",
                };
                setVerifyCoveragePayload(verifyCoveragePayload);
            }
            else if (selection.choice === "Modifica l'indirizzo di copertura") {
                setOpnetCoverageResponse(null);
                setConnectivityFormResponse(null);
                setOpnetCoverageResponse({ result: 'return_form' });
            }
        }
        else {
            const addressDetails = {
                city: selection.city,
                address: selection.address,
                civic: selection.civic,
            };
            setConnectivityForm(addressDetails);
        }
    };
    const saveOpnetCoverageResponse = (finalResponse) => {
        if (finalResponse.message === 'success' && finalResponse.data && finalResponse.data.prodotti[0]) {
            const respProduct = finalResponse.data.prodotti[0];
            if (respProduct.tecnologia && respProduct.connettivita) {
                var technologyCode = respProduct.tecnologia ? respProduct.tecnologia.split('_')[0] : ':';
                var key = 'connectivity.opnet.technology.name.' + technologyCode;
                var technologyName = t(key);
                const iconMap = {
                    FibraIcon: FibraIcon,
                    RameIcon: RameIcon,
                    MistoRadioIcon: MistoRadioIcon,
                    RadioIcon: RadioIcon,
                };
                var iconKey = "connectivity.opnet.technology.icon." + technologyCode;
                var iconValue = t(iconKey);
                const IconComponent = iconMap[iconValue] || null;
                setOpnetCoverageResponse({ technology: respProduct.tecnologia, connectivity: respProduct.connettivita,
                    result: 'success', technologyCode: technologyCode, technologyName: technologyName, iconComponent: IconComponent });
                sendDataLayerConnectivityResult(true);
            }
        }
        else {
            setOpnetCoverageResponse({ result: 'no_coverage' });
            sendDataLayerConnectivityResult(false);
        }
    };
    const sendDataLayerProductAction = () => {
        let pid = document.querySelector('.connectivity-container').getAttribute('data-pid');
        let data = {
            'forcedPipeline': 'ProductAction',
            'pid': pid,
            'ctaText': t('connectivity.cta.active'),
            'prod_type': 'Prodotti Connettività'
        };
        analyticsUtils.passThroughProcessor(data);
    };
    const handleActiveClick = () => {
        sendDataLayerProductAction();
        setActiveError('');
        setTimeout(() => {
            window.location.href = props.leadurl;
        }, 500);
    };
    if (!customer) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Breadcrumbs, { homeurl: props.homeurl, pageactive: t('common.connectivitycoverage') }),
        ' ',
        React.createElement("div", { className: classNames('connectivity-wrapper', { business: (customer.profile && customer.profile.customerType === 'BSN') }) }, (customer.profile && customer.profile.customerType === 'BSN') ? (React.createElement("div", { className: "connectivity--business" },
            React.createElement("h1", { className: "font-primary-2xl-bold connectivity-title" }, t('connectivity.business.stop.title')),
            React.createElement("p", { className: "font-primary-s-regular connectivity-description", dangerouslySetInnerHTML: { __html: t('connectivity.business.stop.description') } }),
            React.createElement("a", { href: props.homeurl, className: "cta cta-secondary" }, t('cart.empty.cta')))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "connectivity--left" },
                React.createElement("div", { className: "copy-section" }, opnetCoverageResponse ? (React.createElement(React.Fragment, null,
                    React.createElement("h1", { className: "font-primary-2xl-bold connectivity-title" }, opnetCoverageResponse.result === 'success' ? t('connectivity.verify.success.title') : t('connectivity.verify.error.title')),
                    React.createElement("p", { className: "font-primary-s-regular connectivity-description" },
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: t('connectivity.verify.success.description') } }),
                        React.createElement("button", { type: "button", className: "link-default reload-connectivity-btn", onClick: () => {
                                setConnectivityFormResponse(null);
                                setOpnetCoverageResponse(null);
                            } }, t('common.click'))))) : (React.createElement(React.Fragment, null,
                    React.createElement("h1", { className: "font-primary-2xl-bold connectivity-title" }, t('connectivity.verify.title')),
                    React.createElement("p", { className: "font-primary-s-regular connectivity-description" }, t('connectivity.verify.description')),
                    ' ')))),
            React.createElement("div", { className: "connectivity--right" },
                React.createElement("div", null, isModalOpen && (React.createElement(AddressNotFoundModal, { closeModal: closeModal, onVerifyCoverage: handleVerifyCoverage, addressSuggestions: addressSuggestions, addressSuggestionsNumMax: props.addresssuggestionmaxnum }))),
                opnetCoverageResponse ? (React.createElement("div", { className: "feedback-section" }, opnetCoverageResponse.result === 'success' ? (React.createElement("div", { className: "active-address-container" },
                    React.createElement("p", { className: "font-primary-s-regular feedback-verify-description", dangerouslySetInnerHTML: { __html: t('connectivity.feedback.success.description', { 0: opnetCoverageResponse.technologyName }) } }),
                    React.createElement("p", { className: "font-primary-s-bold feedback-verify-details", dangerouslySetInnerHTML: { __html: t('connectivity.feedback.success.details', { 0: opnetCoverageResponse.technologyCode }) } }),
                    React.createElement("div", { className: "coverage-info" },
                        React.createElement("div", { className: "coverage-item" },
                            React.createElement("div", { className: "icon-wrapper" },
                                React.createElement("svg", { className: "coverage-icon", width: "18", height: "16" },
                                    React.createElement("use", { xlinkHref: "#sprite-check-orange" }))),
                            React.createElement("div", { className: "font-primary-s-bold coverage-text" }, " Connettivit\u00E0 "),
                            React.createElement("div", { className: "font-primary-s-regular coverage-value" }, opnetCoverageResponse.connectivity)),
                        React.createElement("div", { className: "coverage-item" },
                            React.createElement("div", { className: "icon-wrapper" },
                                React.createElement("svg", { className: "coverage-icon", width: "18", height: "16" },
                                    React.createElement("use", { xlinkHref: "#sprite-check-orange" }))),
                            React.createElement("div", { className: "font-primary-s-bold coverage-text" }, " Tecnologia "),
                            React.createElement("div", { className: "font-primary-s-regular coverage-value" }, opnetCoverageResponse.technology)),
                        React.createElement("div", { className: "font-primary-s-regular coverage-item" },
                            React.createElement("div", { className: "icon-wrapper" },
                                React.createElement("div", { className: "coverage-placeholder" })),
                            React.createElement("div", { className: "font-primary-s-regular coverage-text" }, opnetCoverageResponse.iconComponent && React.createElement(opnetCoverageResponse.iconComponent, null)))),
                    React.createElement("button", { type: "button", className: "cta cta-primary connectivity-active-btn", onClick: handleActiveClick, disabled: !props.leadurl },
                        React.createElement("span", null, t('connectivity.cta.active'))),
                    activeError && React.createElement("div", { className: "invalid--feedback" }, activeError))) : opnetCoverageResponse.result === 'no_coverage' ? (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "font-primary-s-regular feedback-description-verify", dangerouslySetInnerHTML: { __html: t('connectivity.feedback.error.title.opnet') } }),
                    React.createElement("p", { className: "font-primary-s-regular feedback-description-verify", dangerouslySetInnerHTML: { __html: t('connectivity.feedback.error.description') } }),
                    React.createElement("a", { href: props.homeurl, className: "cta cta-primary" }, t('connectivity.cta.home')))) : opnetCoverageResponse.result === 'return_form' ? (React.createElement(React.Fragment, null,
                    React.createElement("div", null),
                    setConnectivityFormResponse(null),
                    setOpnetCoverageResponse(null))) : null)) : (React.createElement(ConnectivityForm, { setConnectivityForm: setConnectivityForm, connectivityFormResponse: connectivityFormResponse, googledisabled: props.googledisabled })))))),
        React.createElement("div", { className: "connectivity-big-ball d-tl-block" }),
        React.createElement("div", { className: "connectivity-small-ball d-tl-block" })));
};
export default withTranslation()(ConnectivityPage);
